import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Message } from "primereact/message";
import { Growl } from "primereact/growl";
import servicioAsignacionValoresObjetos from "../servicio/ServicioObjetos";
import servicioHttp from "../servicio/ServicioHttp";
// import { Dropdown } from 'primereact/dropdown';
export class Trabajador extends React.Component {
  constructor() {
    super();
    this.state = {
      movimientos: [
        { name: "Reingreso", code: "Reingreso" },
        { name: "Modificación", code: "Modificación" },
        { name: "Baja", code: "Baja" },
      ],
      trabajador: {},
      mostraModalTrabajador: false,
      mostrarModalConfirmacion: false,
      erroresRequeridos: {},
      errores: {},
      paginacion: { registrosPorPagina: 20 },
      idsenube: 0,
    };
  }


  componentDidMount() {
    this.obtenerPagina();
  }


  obtenerPagina() {
    servicioHttp
      .consumirPostHttp("trabajador/consulta.json")
      .then((response) => {
        this.setState({ paginacion: response.data.objeto });
      })
      .catch((error) => {
        return this.growl.show({
          severity: "error",
          summary: "",
          detail:
            "Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde",
        });
      });
  }

  mostrarModal() {
    this.setState({ mostraModalTrabajador: true });
  }
  asignarValores = (event) => {
    servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, false);
  };

  guardar() {
    let { trabajador } = this.state;
    const validacion = this.validarFormulario(trabajador);
    this.setState({ errores: validacion });
    if (!Object.keys(validacion).length) {
        servicioHttp
      .consumirPostHttp("trabajador/guardar.json", trabajador)
      .then((response) => {
        this.growl.show({
          severity: response.data.error === false ? "success" : "error",
          summary: "",
          detail: response.data.mensaje,
        });
        this.resetEstados();
        this.obtenerPagina();
      })
      .catch((error) => {
        return this.growl.show({
          severity: "error",
          summary: "",
          detail:
            "Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde",
        });
      });
    }
  }

  resetEstados() {
    this.setState({
      mostraModalTrabajador: false,
      mostrarModalConfirmacion: false,
      trabajador: {},
      erroresRequeridos: {},
      errores: {}
    });
  }

  validarFormulario = (trabajador) => {
    const errores = {};
    if (!trabajador.nombre) errores.nombre = "El campo es requerido";
    if (!trabajador.primerApellido)
      errores.primerApellido = "El campo es requerido";
    if (!trabajador.numeroSeguridadSocial)
      errores.numeroSeguridadSocial = "El campo es requerido";
    if (!trabajador.curp)
      errores.curp = "El campo es requerido";
    if (!trabajador.segundoApellido)
      errores.segundoApellido = "El campo es requerido";
    return errores;
  };

  preeditar(objeto) {
    var trabajadorEditar = JSON.parse(JSON.stringify(objeto));
    this.setState({
      mostraModalTrabajador: true,
      trabajador: trabajadorEditar,
    });
  }

  eliminar = () => {
    let { trabajador } = this.state;
    servicioHttp
      .consumirPostHttp("trabajador/eliminar.json", trabajador)
      .then((response) => {
        this.growl.show({
          severity: response.data.error === false ? "success" : "error",
          summary: "",
          detail: response.data.mensaje,
        });
        this.resetEstados();
        this.obtenerPagina();
      })
      .catch((error) => {
        return this.growl.show({
          severity: "error",
          summary: "",
          detail:
            "Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde",
        });
      });
  };

  mostrarModalEliminar = (objeto) => {
    this.setState({ mostrarModalConfirmacion: true, trabajador: objeto });
  };

  plantillaOpciones(rowData, column) {
    return (
      <div className="p-grid">
        <div className="p-col-12 p-md-2">
          <Button
            type="button"
            icon="pi-md-edit"
            onClick={(e) => this.preeditar(column.rowData)}
            className="p-button-warning"
            name="editar"
            tooltip="Editar"
          ></Button>
          <Button
            type="button"
            icon="pi-md-delete"
            onClick={(e) => this.mostrarModalEliminar(column.rowData)}
            className="p-button-danger"
            name="eliminar"
            tooltip="Eliminar"
          ></Button>
        </div>
      </div>
    );
  }

  render() {
    let { trabajador, errores, paginacion } = this.state;
    const pieDialogo = (
      <div className="ui-dialog-buttonpane p-clearfix">
        <Button
          label="Guardar"
          icon="pi-md-save"
          onClick={this.guardar.bind(this)}
        />
        <Button
          label="Cancelar"
          icon="pi-md-close"
          onClick={this.resetEstados.bind(this)}
          className="p-button-danger "
        />
      </div>
    );
    const dialogFooterConfirmacionEliminar = (
      <div>
        <Button
          icon="pi-md-check"
          onClick={this.eliminar}
          label="Si estoy seguro"
        />
        <Button
          icon="pi-md-close"
          onClick={() =>
            this.setState({
              trabajador: {},
              mostrarModalConfirmacion: false,
              errores: {},
            })
          }
          label="No estoy seguro"
          className="p-button-danger flat-btn"
        />
      </div>
    );
    return (
      <div className="p-grid">
        <Growl ref={(el) => (this.growl = el)} />
        <div className="p-col-12">
          <div className="card card-w-title">
            <h1>Trabajador</h1>
            {/* <div className="p-fluid p-grid">
              <div className="p-col-12 p-md-4">
                <Button
                  className="p-button-Primary p-button-raised"
                  label="Agregar"
                  icon="pi-md-plus"
                  tooltip={"Agregar nuevo"}
                  onClick={this.mostrarModal.bind(this)}
                />
              </div>
            </div> */}
          </div>
        </div>
        <Dialog
          visible={this.state.mostraModalTrabajador}
          header="Datos del trabajador"
          modal={true}
          footer={pieDialogo}
          onHide={this.resetEstados.bind(this)}
        >
          <h4>
            Los campos con (*) son obligatorios, por favor captura los datos del
            trabajador
          </h4>
          <div className="p-grid">
            <div className="p-col-12 p-md-2">
              <label htmlFor="rfc">*Nombre:</label>
            </div>
            <div className="p-col-12 p-md-4">
              <InputText
                id="nombre"
                name="trabajador.nombre"
                className={errores.nombre ? "p-error" : ""}
                value={trabajador.nombre || ""}
                onChange={this.asignarValores.bind(this)}
                style={{ width: "100%" }}
              />
              {errores.nombre ? (
                <div>
                  <br /> <Message severity="error" text={errores.nombre} />{" "}
                </div>
              ) : null}
            </div>
            <div className="p-col-12 p-md-2">
              <label htmlFor="primerApellido">*Primer Apellido:</label>
            </div>
            <div className="p-col-12 p-md-4">
              <InputText
                id="primerApellido"
                name="trabajador.primerApellido"
                className={errores.primerApellido ? "p-error" : ""}
                value={trabajador.primerApellido || ""}
                onChange={this.asignarValores.bind(this)}
                style={{ width: "100%" }}
              />
              {errores.primerApellido ? (
                <div>
                  <br />{" "}
                  <Message severity="error" text={errores.primerApellido} />{" "}
                </div>
              ) : null}
            </div>
            <div className="p-col-12 p-md-2">
              <label htmlFor="segundoApellido">Segundo Apellido:</label>
            </div>
            <div className="p-col-12 p-md-4">
              <InputText
                id="segundoApellido"
                name="trabajador.segundoApellido"
                className={errores.segundoApellido ? "p-error" : ""}
                value={trabajador.segundoApellido || ""}
                onChange={this.asignarValores.bind(this)}
                style={{ width: "100%" }}
              />
              {errores.segundoApellido ? (
                <div>
                  <br />{" "}
                  <Message severity="error" text={errores.segundoApellido} />{" "}
                </div>
              ) : null}
            </div>

            <div className="p-col-12 p-md-2">
              <label htmlFor="curp">Curp:</label>
            </div>
            <div className="p-col-12 p-md-4">
              <InputText
                id="curp"
                name="trabajador.curp"
                className={errores.curp ? "p-error" : ""}
                value={trabajador.curp || ""}
                onChange={this.asignarValores.bind(this)}
                style={{ width: "100%" }}
              />
              {errores.curp ? (
                <div>
                  <br /> <Message severity="error" text={errores.curp} />{" "}
                </div>
              ) : null}
            </div>
            <div className="p-col-12 p-md-2">
              <label htmlFor="numeroSeguroSocial">
                Número de Seguro Social:
              </label>
            </div>
            <div className="p-col-12 p-md-4">
              <InputText
                id="numeroSeguroSocial"
                name="trabajador.numeroSeguridadSocial"
                className={errores.numeroSeguridadSocial ? "p-error" : ""}
                value={trabajador.numeroSeguridadSocial || ""}
                onChange={this.asignarValores.bind(this)}
                style={{ width: "100%" }}
              />
              {errores.numeroSeguridadSocial ? (
                <div>
                  <br />{" "}
                  <Message
                    severity="error"
                    text={errores.numeroSeguridadSocial}
                  />{" "}
                </div>
              ) : null}
            </div>
          </div>
        </Dialog>
        <Dialog
          header="Confirmación"
          visible={this.state.mostrarModalConfirmacion}
          modal={true}
          style={{ width: "30vw" }}
          footer={dialogFooterConfirmacionEliminar}
          onHide={() =>
            this.setState({
              cliente: {},
              mostrarModalConfirmacion: false,
              errores: {},
            })
          }
        >
          <h2>¿Estás seguro de eliminar el trabajador?</h2>
        </Dialog>
        <div className="p-col-12">
          <div className="card card-w-title">
            <DataTable
              value={paginacion.datos}
              editable={true}
              selectionMode="single"
              responsive={true}
              header="Trabajadores"
              paginator={true}
              rows={20}
            >
              <Column field="nombre" header="Nombre" autoLayout={true} />
              <Column
                field="primerApellido"
                header="Primer Apellido"
                autoLayout={true}
              />
              <Column
                field="segundoApellido"
                header="Segundo Apellido"
                autoLayout={true}
              />

              <Column
                header="Opciones"
                body={this.plantillaOpciones.bind(this)}
                autoLayout={true}
              />
            </DataTable>
          </div>
        </div>
      </div>
    );
  }
}
